import { render, staticRenderFns } from "./wsTextField.vue?vue&type=template&id=2040945c&scoped=true&"
import script from "./wsTextField.vue?vue&type=script&lang=js&"
export * from "./wsTextField.vue?vue&type=script&lang=js&"
import style0 from "./wsTextField.vue?vue&type=style&index=0&id=2040945c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2040945c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDivider,VIcon,VSheet,VTextField,VTextarea})
